export enum UserTypeId {
  ROOT = 1,
  CUSTOMER = 2,
  PARTNER = 3,
  SALESMAN = 4,
  CONNECTOR = 5,
  GUEST = 6,
}
